define('GameDayCore/GDModel/ValueObjects/Scoreboard/Miniscoreboard/GameMiniscoreboardOffense',['require','exports','module','../../ValueObjectFactory'],function(require, exports, module) {
	var VO = require('../../ValueObjectFactory');

	VO.create(GameMiniscoreboardOffense);

	function GameMiniscoreboardOffense($data) {
		var vo = VO.ensureVO(this, GameMiniscoreboardOffense),
			data = $data;

		vo.id = data.id || "";
		vo.team_code = data.team_code || "";
		vo.hr = data.hr || "";
		vo.std_hr = data.std_hr || "";
		vo.inning = data.inning || "";
		vo.runners = data.runners || "";
		vo.number = data.number || "";
		vo.first = data.first || "";
		vo.last = data.last || "";
		vo.name_full = vo.first + " " + vo.last || "";
		vo.name_display_roster = data.name_display_roster || "";
	}

	return GameMiniscoreboardOffense;
});
